import React from "react";
import { Grid, Center, Text, Progress } from "@mantine/core";
import "../../corralpagewrapper.css";

const glyphCost = 200;

const OctagramIcon = ({ size = 24, color = "gold" }) => (
  <svg
    className="octagram-icon"
    width={size}
    height={size}
    viewBox="0 0 100 100"
    aria-hidden="true"
    focusable="false"
    style={{ overflow: "visible" }}
  >
    <polygon
      fill={color}
      className="octagram-shape"
      points="
        50.0,0.0
        57.7,31.5
        85.4,14.6
        68.5,42.3
        100.0,50.0
        68.5,57.7
        85.4,85.4
        57.7,68.5
        50.0,100.0
        42.3,68.5
        14.6,85.4
        31.5,57.7
        0.0,50.0
        31.5,42.3
        14.6,14.6
        42.3,31.5
      "
    />
  </svg>
);

const SkillSlotIndicator = ({ manaPool }) => {
  const totalSkillSlots = Math.floor(manaPool / glyphCost);
  const leftOver = manaPool % glyphCost;
  const progressToNextSlot = Math.floor((leftOver / glyphCost) * 100);
  const amountToNextSlot = glyphCost - leftOver;

  return (
    <>
      <Center m="xs">
        <Text fw={800}>{totalSkillSlots} Slots Available</Text>
      </Center>

      <Grid align="center">
        <Grid.Col span={1} className="octagram-wrapper">
          <Center style={{ flexDirection: "column", gap: 4 }}>
            <OctagramIcon size={28} color="#6495ED" />
            <Text size="xs" fw={700}>
              0
            </Text>
          </Center>
        </Grid.Col>

        <Grid.Col span={10}>
          <Progress.Root size={18} radius="lg">
            <Progress.Section
              value={progressToNextSlot}
              color="#FFD700"
              animated
            >
              <Progress.Label>
                <Text fw={800} c="black">
                  {leftOver}
                </Text>
              </Progress.Label>
            </Progress.Section>
            <Progress.Section
              value={100 - progressToNextSlot}
              color="rgba(0, 0, 0, 0.35)"
            >
              <Progress.Label>
                <Text fw={800} c="white">
                  {amountToNextSlot}
                </Text>
              </Progress.Label>
            </Progress.Section>
          </Progress.Root>
        </Grid.Col>

        <Grid.Col span={1} className="octagram-wrapper">
          <Center style={{ flexDirection: "column", gap: 4 }}>
            <OctagramIcon size={28} color="#B22222" />
            <Text size="xs" fw={700}>
              {glyphCost}
            </Text>
          </Center>
        </Grid.Col>
      </Grid>
    </>
  );
};

export default SkillSlotIndicator;
